module.exports = __webpack_public_path__ + "img/achievement_21.887663d1.png";